import { MODALITY, InstanceOrientation, MORPHOLOGY_ORIENTATION_ORDER } from "../classes/enums/MedicalImagesEnum";

export const CORE_CONFIG = [
    {
      modality: MODALITY.DX,
      orientation: InstanceOrientation.Sagittal,
      key: "DX",
    },
    {
      modality: MODALITY.DX,
      orientation: InstanceOrientation.Coronal,
      key: "DX",
    },
    {
      modality: MODALITY.CT,
      key: "CT",
    },
    {
      modality: MODALITY.MR,
      key: "MRI",
    },
  ];

  // Re-export for backwards compatibility
  export const POSTURE_ORDER = MORPHOLOGY_ORIENTATION_ORDER;